import apiClient from './config'
import { isAuthenticated } from './auth'

function getToken() {
  return localStorage.getItem('token') || ''
}

function getLocale() {
  return localStorage.getItem('locale') || 'en'
}

function submitForm(params) {
  var form = document.createElement('form')
  form.method = 'POST'
  form.action = apiClient.defaults.baseURL + '/buy/payHandlerV2'
  
  Object.keys(params).forEach(function(key) {
    if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
      var input = document.createElement('input')
      input.type = 'hidden'
      input.name = key
      input.value = params[key]
      form.appendChild(input)
    }
  })
  
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

function submitJson(params, url) {
  return fetch(apiClient.defaults.baseURL + url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(params)
  }).then(function(response) {
    return response.json()
  })
}

var stripeApi = {
  createSubscription: function(planId, billingCycle, planData, isUpgrade) {
    var payType = billingCycle === 'yearly' ? 1 : 2
    var params = {
      stripe_price_id: planData.stripePriceId,
      price: String(planData.price),
      credits: String(planData.credits),
      ext_credits: String(planData.bonusCredits),
      pay_type: payType,
      plan_name: planId,
      miToken: getToken(),
      pay_mode: '1',
      updateSubscription: isUpgrade ? 1 : 0,
      locale: getLocale()
    }
    submitForm(params)
  },

  upgradeSubscription: function(planId, billingCycle, planData) {
    var payType = billingCycle === 'yearly' ? 1 : 2
    var params = {
      stripe_price_id: planData.stripePriceId,
      price: String(planData.price),
      credits: String(planData.credits),
      ext_credits: String(planData.bonusCredits),
      pay_type: payType,
      plan_name: planId,
      miToken: getToken(),
      pay_mode: '1',
      updateSubscription: 1,
      locale: getLocale()
    }
    return submitJson(params, '/buy/payUpgrade')
  },

  createCreditsPurchase: function(creditsOption) {
    var planNameMap = {
      1200: 'extCredits1',
      3000: 'extCredits2',
      6000: 'extCredits3',
      12000: 'extCredits4'
    }
    var params = {
      stripe_price_id: creditsOption.stripePriceId || '',
      price: String(creditsOption.price),
      credits: String(creditsOption.credits),
      plan_name: planNameMap[creditsOption.credits] || 'extCredits1',
      miToken: getToken(),
      pay_mode: '2',
      locale: getLocale()
    }
    submitForm(params)
  },

  getSubscription: function() {
    return apiClient.get('/buy/subscription')
  },

  cancelSubscription: function() {
    return apiClient.post('/buy/cancel-subscription')
  },

  paySubscription: function(opt) {
    return apiClient.post('/buy/paySubscription', {
      miToken: getToken(),
      opt: opt
    })
  },

  restoreSubscription: function() {
    return apiClient.post('/buy/paySubscription', {
      miToken: getToken(),
      opt: 1
    })
  },

  getPaymentHistory: function(pageNumber, pageSize) {
    return apiClient.post('/buy/payList', {
      miToken: getToken(),
      state: 0,
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 10
    })
  },

  generateInvoicePdf: function(invoiceData) {
    var data = {
      miToken: getToken(),
    }
    if (invoiceData) {
      Object.assign(data, invoiceData)
    }
    return apiClient.post('buy/generatePdf', data)
  }
}

export function createSubscription(planId, billingCycle, planData, isUpgrade) {
  return stripeApi.createSubscription(planId, billingCycle, planData, isUpgrade)
}

export function upgradeSubscription(planId, billingCycle, planData) {
  return stripeApi.upgradeSubscription(planId, billingCycle, planData)
}

export function createCreditsPurchase(creditsOption) {
  return stripeApi.createCreditsPurchase(creditsOption)
}

export function getSubscription() {
  return stripeApi.getSubscription()
}

export function cancelSubscription() {
  return stripeApi.cancelSubscription()
}

export function getPaymentHistory(pageNumber, pageSize) {
  return stripeApi.getPaymentHistory(pageNumber, pageSize)
}

export function generateInvoicePdf(invoiceData) {
  return stripeApi.generateInvoicePdf(invoiceData)
}

export function paySubscription(opt) {
  return stripeApi.paySubscription(opt)
}

export default stripeApi
